// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__WtJbt","menu__container":"Menu_menu__container__5ySJh","slideIn":"Menu_slideIn__eCXC3","menu__lang-sel":"Menu_menu__lang-sel__tZRlx"};